import { createUseStyles } from 'react-jss';

import { mediaQuery, Transition } from '../../../styles';
import { ITheme } from '../../../styles/theme';

const useStyles = createUseStyles(
  ({ breakpoints, layout }: ITheme) => ({
    container: {
      padding: [0, '48px'],

      [mediaQuery(breakpoints.tablet)]: {
        padding: [0, '24px'],
      },
    },
    root: {
      maxWidth: layout.maxWidth,
      margin: '0 auto 40px auto',
    },
    header: {
      textAlign: 'center',
    },
    label: {
      color: 'var(--x-text-color-2) !important',
      fontWeight: '500',
      marginBottom: '0.8571rem',
    },
    title: {
      fontWeight: '500 !important',
      marginBottom: '2.8571rem',

      [mediaQuery(breakpoints.tablet)]: {
        fontSize: '2.25rem !important',
        lineHeight: '3rem !important',
        marginBottom: '1.7143rem',
      },
    },
    list: {
      listStyle: 'none',
      margin: 0,
      padding: 0,

      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
    },
    listItem: {
      display: 'flex',
      flexBasis: '25%',
      padding: '16px 14px',
      boxSizing: 'border-box',

      [mediaQuery(breakpoints.laptop)]: {
        flexBasis: '33%',
      },

      [mediaQuery(breakpoints.tablet)]: {
        flexBasis: '100%',
      },
    },
    cardLink: {
      flex: 1,
      display: 'block',
      transition: `box-shadow ${Transition.Fast} ease-in-out`,

      padding: '16px 8px',
      borderRadius: '8px',

      '&:hover': {
        boxShadow: '0px 1px 4px 1px var(--x-shadow-card)',
      },
    },
  }),
  {
    name: 'card-image-section',
  },
);

export default useStyles;
